import { compactViewMixin } from '../../../mixins/compactViewMixin/compactViewMixin';
export let compactViewMixinPage = compactViewMixin;
